import { Point } from "pixi.js";
import { BoosterButtonBase } from "../../../../common/components/BoosterButtonBase";
import { BoosterType } from "../../../../common/models/data/BoosterType";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";

export class BoosterButton extends BoosterButtonBase {
    public get width(): number {
        return 205;
    }

    public get height(): number {
        return 180;
    }

    public get countSubstratePosition() {
        return this.countSubstrate.position;
    }

    public set countSubstratePosition(value: Point) {
        this.countSubstrate.position.set(value.x, value.y);
    }

    public constructor(commonResources: CommonResourcesPackage, type: BoosterType, value: number = 0, level: number = 1, isAdAvailable: boolean = false) {
        super(commonResources, type, value, level, isAdAvailable);
    }
}
